<template>
    <div v-if="packages" class="section__packs mb-20 md:mb-34">
        <div class="gs:grid">
            <div class="md:col-8 tx-center sm:tx-left mb-10 md:mb-0 wow slideInUp">
                <p class="tx-14 sm:tx-16 tx-blue-1 mb-5">
                    Conoce nuestros paquetes
                </p>
                <h3 class="tx-30 sm:tx-35 lg:tx-46 xl:tx-52 tx-grey-1 weight-500 mb-6 md:mb-9">
                    Vende tu auto rápido <br> y sin complicaciones
                </h3>
                <p class="tx-14 lg:tx-16 tx-purple-1 mb-8 md:mb-15 line-h-soft">
                    Elige el paquete que mejor se adapte a ti.
                </p>
                <div class="flex align-items-center justify-content-center sm:justify-content-start">
                    <div class="flex justify-content-center align-items-center bg-lightgrey-1 rounded-4 px-3 py-3 mr-3">
                        <img class="lazyload" width="20px" data-src="/assets/images/helpers/pay_methods/mastercard.svg" alt="">
                    </div>
                    <div class="flex justify-content-center align-items-center bg-lightgrey-1 rounded-4 px-3 py-3 mr-3">
                        <img class="lazyload" width="52px" data-src="/assets/images/helpers/pay_methods/oxxopay.svg" alt="">
                    </div>
                    <div class="flex justify-content-center align-items-center bg-lightgrey-1 rounded-4 px-3 py-3 mr-3">
                        <img class="lazyload" width="52px" data-src="/assets/images/helpers/pay_methods/paypal.svg" alt="">
                    </div>
                    <div class="flex justify-content-center align-items-center bg-lightgrey-1 rounded-4 px-3 py-3">
                        <img class="lazyload" width="32px" data-src="/assets/images/helpers/pay_methods/visa.svg" alt="">
                    </div>
                </div>
            </div>
            <div class="md:col-8 xl:col-7 xxxl:col-6 ml-a wow fadeIn" data-wow-delay="0.4s">
                <div class="wrapper-swiper-out">
                    <div class="wa-push wa-push--1 wow zoomIn" data-wow-delay="1s">
                        <div class="flex align-items-center mb-2">
                            <img class="mr-2 lazyload" data-src="/assets/images/pages/home/packs/icon-wa.png" alt="">
                            <img class="lazyload" src="/assets/images/pages/home/packs/tx-wa.png" alt="">
                        </div>
                        <p class="m-0">
                            <strong>Fernando Lomeli</strong>
                        </p>
                        <p class="m-0">
                            ¿El precio es negociable? Me interesa!!
                        </p>
                    </div>
                    <div class="wa-push wa-push--2 wow zoomIn" data-wow-delay="0.5s">
                        <div class="flex align-items-center mb-2">
                            <img class="mr-2 lazyload" data-src="/assets/images/pages/home/packs/icon-wa.png" alt="">
                            <img class="lazyload" data-src="/assets/images/pages/home/packs/tx-wa.png" alt="">
                        </div>
                        <p class="m-0">
                            <strong>Mónica Pérez</strong>
                        </p>
                        <p class="m-0">
                            ¿Te interesaría un cambio? Esta padrísimo el <br> coche, te dejo mi correo por aquí.
                        </p>
                    </div>
                    <div class="wa-push wa-push--3 wow zoomIn" data-wow-delay="1.5s">
                        <div class="flex align-items-center mb-2">
                            <img class="mr-2 lazyload" data-src="/assets/images/pages/home/packs/icon-wa.png" alt="">
                            <img class="lazyload" data-src="/assets/images/pages/home/packs/tx-wa.png" alt="">
                        </div>
                        <p class="m-0">
                            <strong>Arturo López</strong>
                        </p>
                        <p class="m-0">
                            Me interesa mucho tu auto ¿Es precio fijo?
                        </p>
                    </div>
                    <div class="swiper-packs swiper-container">
                        <swiper class="swiper-wrapper" :options="swiperOptionTop" ref="swiperLastViews">
                            <swiper-slide v-for="(paquete, key) in packages" :key="key">
                                <div class="pack tx-center pb-8 xl:pb-12">
                                    <div class="pt-8 xl:pt-12 xl:px-24">
                                        <h3 class="tx-22 md:tx-28 tx-grey-1 weight-700 mb-5" v-html="paquete.title" />
                                        <p class="tx-56 md:tx-64 lg:tx-74 xl:tx-96 tx-pink-1 weight-900">
                                        <span class="tx-grey-1 tx-16 inline-block xl:-mr-3">$</span>
                                            {{ formatNumber(paquete.price) }}
                                        </p>
                                        <p class="tx-14 weight-500 tx-grey-1">
                                            Pesos (MXN)
                                        </p>
                                    </div>
                                    <ul class="list bullet-inside tx-14 tx-grey-1 weight-700 px-8 xl:px-13 mb-8">
                                        <li v-for="(feature, feature_key) in paquete.features" :key="feature_key">
                                            {{ feature.title + ' ' + feature.subtitle }}
                                        </li>
                                    </ul>
                                    <!-- <a class="btn btn--pink btn--packs tx-12 md:tx-16" :href="external_link">
                                        Ver paquetes <img class="ml-2" width="11px" src="/assets/images/helpers/arrow-right.svg" alt="">
                                    </a> -->
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="swiper-button-prev swiper-button-prev-packs" slot="button-prev">
                        <img src="/assets/images/helpers/icon-angle-right.svg" alt="">
                    </div>
                    <div class="swiper-button-next swiper-button-next-packs" slot="button-next">
                        <img src="/assets/images/helpers/icon-angle-right.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ThumbnailCarComponent from '../../layout/ThumbnailCarComponent';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
    props: ['external_link'],
    data() {
        return {
            callAsync: false,
            packages: null,
            swiperOptionTop: {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 29,

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next-packs',
                    prevEl: '.swiper-button-prev-packs'
                },
            },

            formData: null,
            err: {}
        }
    },

    components: {
        ThumbnailCarComponent,
        Swiper,
        SwiperSlide
    },

    created() {
        let vm = this;
        vm.getPackagesAsync();
    },

    methods: {

        async getPackagesAsync() {
            let vm = this;
            if (!vm.callAsync) {
                vm.resetForms();
                vm.callAsync = true;

                try {

                    let {data} = await axios.get('/client/home/packages');
                    vm.packages = data;
                    vm.callAsync = false;
                } catch (error) {
                    console.log(error);
                    vm.callAsync = false;
                }
            }
        },

        formatNumber(value) {
            let val = (value / 1).toFixed(0).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        showErrors(error = null) {
            let vm = this;
            if ( error ) {
                vm.err = error.response.data;
            }
            vm.$swal({
                icon: 'error',
                title: 'Error',
                text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
            });
        },

        resetForms() {
            let vm = this;
            vm.formData = new FormData();
            vm.err = [];
        },
    },

}
</script>
